import { API } from '.';
import QueryString from 'qs';
import { Utils } from '../helpers/Utils';

class InfoSessionService {
    async getCompanySessions(companyId) {
        const query = QueryString.stringify(
            {
                filters: {
                    company: { id: { $eq: companyId } },
                },
                sort: ['sessionTime:asc'],
            },
            { encodeValuesOnly: true },
        );

        const response = await API.get(`/api/info-sessions?${query}`);
        if (!response) return [];
        return Utils.deepFlatten(response.data.data);
    }

    async createSession(companyId, data) {
        const response = await API.post('/api/info-sessions', {
            data: {
                ...data,
                company: companyId,
            },
        });
        return response.data.data;
    }

    async updateSession(sessionId, data) {
        const response = await API.put(`/api/info-sessions/${sessionId}`, {
            data,
        });
        return response.data.data;
    }

    async deleteSession(sessionId) {
        await API.delete(`/api/info-sessions/${sessionId}`);
    }
}

export default InfoSessionService;
